import React, { useState, useEffect } from "react";
import { logoEli } from "../../assets";
import axios from "../../lib/axios";
import errorHandler from "../../helpers/errorHandler";
import { MySwal } from "../../lib/swal";
import { IconDeviceFloppy } from "@tabler/icons-react";
import SelectProgram from "react-select";

const CoachingParticipantsPage = () => {
  const [programs, setPrograms] = useState("");
  const [disabled, setdisabled] = useState(false);
  const [fullname, setFullname] = useState("");
  const [position, setPosition] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [goals, setGoals] = useState("");
  const [alumniProgram, setAlumniProgram] = useState("");

  const fetchPrograms = async () => {
    try {
      const options = {
        url: "/cms/programs",
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const { data } = await axios(options);
      setPrograms([]);
      data.data.map((program, i) =>
        setPrograms((programs) => [
          ...programs,
          {
            value: program.id,
            label: program.name,
          },
        ])
      );
    } catch (err) {
      if (err) {
        console.log(err?.response?.data);
        // errorHandler({ err: err?.response?.data || err })
      }
    }
  };

  const handleRegistration = () => {
    setdisabled(true);
    const requestBody = {
      fullname: fullname,
      position: position,
      companyName: companyName,
      mobilePhone: mobilePhone,
      email: email,
      goals: goals,
      alumniProgram: alumniProgram,
    };
    // console.log(requestBody);
    // return false;

    axios({
      url: "/users/coaching",
      method: "POST",
      data: requestBody,
    })
      .then((res) => {
        // console.log(res.data.code)
        if (res.data.code === "201") {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Registration Successfully!",
          });

          setTimeout(() => {
            window.location.reload();
          }, 3000);
          setdisabled(false);
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err);
          errorHandler({ err: err?.response?.data || err });
          setdisabled(false);
        }
      });
  };

  const handleChangeProgram = (value) => {
    setAlumniProgram(value.label);
  };

  useEffect(() => {
    fetchPrograms();
  }, []);

  return (
    <>
      <div className="container" style={{ marginTop: "3%" }}>
        <div className="row">
          <div className="col-lg-6 col-12" style={{ margin: "auto" }}>
            <div className="card">
              <img
                src={logoEli}
                alt="logoEli"
                style={{ margin: "auto", marginTop: "3%" }}
              />
              <div className="card-body">
                <h1 className="card-title mb-3" style={{ fontSize: "18px" }}>
                  Coaching Program Registration
                </h1>
                <div className="col-12 mb-3">
                  <label htmlFor="fullname" className="form-label required">
                    Fullname
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="fullname"
                    placeholder="John Doe"
                    onChange={(e) => setFullname(e.target.value)}
                    value={fullname}
                  />
                </div>
                <div className="col-12 mb-3">
                  <label htmlFor="position" className="form-label required">
                    Position
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="position"
                    placeholder="System Analyst"
                    onChange={(e) => setPosition(e.target.value)}
                    value={position}
                  />
                </div>
                <div className="col-12 mb-3">
                  <label htmlFor="companyName" className="form-label required">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="companyName"
                    placeholder="PT. Qwerty Indonesia"
                    onChange={(e) => setCompanyName(e.target.value)}
                    value={companyName}
                  />
                </div>
                <div className="row mb-3">
                  <div className="col-lg-6 col-12">
                    <label htmlFor="email" className="form-label required">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="john.doe@xmail.co"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                    <small className="text-info" style={{ fontWeight: "500" }}>
                      Use the email registered on LMS prasmul-eli.
                    </small>
                  </div>
                  <div className="col-lg-6 col-12">
                    <label
                      htmlFor="mobilePhone"
                      className="form-label required"
                    >
                      Mobile Phone
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="mobilePhone"
                      placeholder="08123456789"
                      onChange={(e) => setMobilePhone(e.target.value)}
                      value={mobilePhone}
                    />
                  </div>
                </div>
                <div className="col-12 mb-3">
                  <label
                    htmlFor="alumniProgram"
                    className="form-label required"
                  >
                    Programs you have participated in
                  </label>
                  {/* <input
                    type="text"
                    className="form-control"
                    id="alumniProgram"
                    placeholder="Self Leadership : Personality Perspective"
                    onChange={(e) => setAlumniProgram(e.target.value)}
                    value={alumniProgram}
                  /> */}
                  <SelectProgram
                    onChange={handleChangeProgram}
                    options={programs}
                    isMulti={false}
                    placeholder="Self Leadership : Personality Perspective"
                  />
                </div>
                <div className="col-12 mb-3">
                  <label htmlFor="goals" className="form-label required">
                    Tell us about your goals, aspirations, and achievements
                    <br /> you want to accomplish
                  </label>
                  <textarea
                    id="goals"
                    className="form-control"
                    rows={4}
                    onChange={(e) => setGoals(e.target.value)}
                    value={goals}
                    placeholder="My main goals for joining this coaching program are to develop (specific skills relevant to the program, such as leadership, project management, or strategic planning)."
                  ></textarea>
                </div>
                <button
                  disabled={disabled}
                  class="btn"
                  style={{
                    marginRight: "10px",
                    backgroundColor: "#26D07C",
                    color: "#F2F2F2",
                  }}
                  onClick={() => handleRegistration()}
                >
                  <IconDeviceFloppy stroke={2} />
                  &nbsp;
                  {disabled === true ? "Loading..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CoachingParticipantsPage;
